export const CV_SET_MENU_DATA = 'CV_SET_MENU_DATA';
export const CV_NODE_SELECTED = 'CV_SET_NODE_SELECTED';
export const CV_PREV_NODE_SELECTED = 'CV_PREV_NODE_SELECTED';
